<template>
  <div id="data-list-list-view" class="data-list-container">
    <h3>Events</h3>

    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      :max-items="itemsPerPage"
      :data="venueTrainings"
      @selected="onVenueTrainingClicked(selected.venueTrainingId)"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- ADD NEW -->
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            @click="
              $router
                .push({ name: 'admin-add-new-venue-training' })
                .catch(() => {})
            "
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add new Event</span>
          </div>
        </div>

        <!-- SEARCH -->
        <div class="vs-table--search relative">
          <input
            v-model="query"
            type="text"
            @keyup="handleSearch"
            class="vs-table--search-input search-field p-2 rounded border border-gray-300 focus:outline-none focus:ring focus:ring-primary"
            placeholder="Search..."
          />
          <i class="vs-icon-search absolute top-2 right-2 text-gray-400"></i>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Title</vs-th>
        <vs-th sort-key="numParticipants">Participants</vs-th>
        <vs-th sort-key="startDate">Start</vs-th>
        <vs-th sort-key="endDate">End</vs-th>
        <vs-th sort-key="instructorDisplayName">Instructor</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.title }}</p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getNumParticipantsColor(tr.numParticipants)"
                class="product-order-status"
                >{{ tr.numParticipants }} / {{ tr.maxParticipants }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.startDate | formatDate }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.endDate | formatDate }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.instructorDisplayName }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="onVenueTrainingClicked(tr.venueTrainingId)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <!-- PAGINATION -->
    <vs-pagination
      :total="Math.ceil(totalItems / itemsPerPage)"
      :page.sync="currentPage"
      @change="handlePageChange"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      query: "", // User input for search
      venueTrainings: [], // Data for table
      totalItems: 0, // Total items for pagination
      currentPage: 1, // Current page for pagination
      itemsPerPage: 50, // Number of items per page
    };
  },
  methods: {
    // Fetch venue trainings from API
    getVenueTrainings() {
      this.$vs.loading();

      const url = `${process.env.VUE_APP_API}/VenueTrainings`;
      const params = {
        query: this.query.trim() === "" ? "*" : this.query.trim(),
        page: this.currentPage,
        pageSize: this.itemsPerPage,
      };

      this.$http
        .get(url, { params })
        .then((resp) => {
          this.venueTrainings = resp.data.items;
          this.totalItems = resp.data.totalItems;

          // Sort by startDate (descending order)
          this.venueTrainings.sort(
            (a, b) => new Date(b.startDate) - new Date(a.startDate)
          );
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    // Handle pagination change
    handlePageChange(page) {
      this.currentPage = page;
      this.getVenueTrainings();
    },

    // Handle search input when Enter is pressed
    handleSearch(event) {
      if (event.key === "Enter") {
        this.currentPage = 1; // Reset to first page
        this.getVenueTrainings();
      }
    },

    // Handle click on a venue training
    onVenueTrainingClicked(venueTrainingId) {
      this.$router
        .push({
          name: "admin-venue-training",
          params: { venueTrainingId },
        })
        .catch(() => {});
    },

    // Assign colors based on participants
    getNumParticipantsColor(numParticipants) {
      return numParticipants === 0 ? "warning" : "success";
    },
  },
  created() {
    this.getVenueTrainings();
  },
};
</script>

<style lang="scss">
.search-field {
  color: rgba(0, 0, 0, 0.7);
  border-radius: 20px !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 12px 5px 12px 10px !important;
}
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>